
import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import { add_to_cart as add_to_cart_helper } from "@/components/cart/cart_helper";
import Swal from "sweetalert2";
import ReportCommentModal from "@/components/ReportCommentModal/ReportCommentModal.vue";
import CreateFeed from '@/components/CreateFeed/CreateFeed.vue'
import Comments from '@/components/Comments/Comments.vue';
import Delivery from "@/components/Delivery/DeliveryView.vue";
import ProductPromoCode from "@/components/PromoCode/product_promo_code.vue";
import CatalogueView from "@/components/Catalogue/CatalogueView.vue";
import { add_attribute_value, group_attributes, remove_attribute } from "@/views/BusinessProfileView/business_profile_helper";
import {
  create_catalogue_item,
  update_catalogue_item,
} from "@/components/Catalogue/catalogue";
import { view_profile_product } from "@/views/Marketplace/marketplace_helpers";
import { view_profile as view_profile_helper } from "@/views/home/home_helper.js";
import { handle_report_realtime } from "@/services/realtime_report_helper";
import { append_active_organization_id, get_active_organization_id } from "@/utils/organization_profile";
function get_id_from_profile_slug(slug) {
  return String(slug || "").match(/-(\d+)$/)?.[1] || "";
}

export default {
  components: {
    HomeNavBar,
    ReportCommentModal,
    CreateFeed,
    Comments,
    Delivery,
    ProductPromoCode,
    CatalogueView
  },
  inject: ['client_features'],
  props: {
    active_profile_data: {
      type: Object,
      default: null
    },
    questions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    rating_level() {
      return ['', 'Terrible', 'Poor', 'Average', 'Good', 'Excellent'][this.hover_rating || this.new_rating] || 'Tap a star to rate';
    },
    circleOffset() {
      const radius = 54
      const circumference = 2 * Math.PI * radius
      const percentage = this.companyData?.completion_percentage || 0
      return circumference - (percentage / 100) * circumference
    },

    pending_orders() {
      return this.orders || []
    },
    pending_requests() {
      return this.requests || []
    },

    catalogue_items() {
      return this.catalogueTab === 'products' ? this.catalogue_products : this.catalogue_services
    },
    catalogue_modal_context() {
      return this;
    },
    is_dropin_selected() {
      // Find the type object in the array that matches the currently selected ID
      const selected_type = this.service_types.find(t => t.id === this.item_form.service_type_id);
      // Return true only if that type's name is 'drop_in'
      return selected_type && selected_type.name === 'drop_in';
    },
    min_date() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      // Returns "YYYY-MM-DDTHH:MM"
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    all_section() {
      // questions is an array of forms, each with form_sections (sections)
      return this.profile_questions.flatMap(form =>
        (form.form?.form_sections || []).map(fs => ({
          ...fs,
          formId: form.form?.id,
          formName: form.form?.name,
          section: fs.section,
          sectionId: fs.section?.id
        }))
      );
    },
    isOwner() {
      if (this.is_owner_view) {
        // If "view as member" mode is active, treat as non-owner
        return false;
      }
      return String(this.companyData?.base_profile?.creater?.id) === String(this.user_details.user_id);
    },
    currentBanner() {
      return this.companyData?.company_banner?.[0]?.file?.file_url || null;
    },
    company_address_lines() {
      const address = this.companyData?.address || {};
      const address_parts = [
        address.street_address,
        address.address_line_2,
        address.suburb,
        address.city,
        address.province,
        address.postal_code,
      ].filter(Boolean);

      if (address_parts.length) return address_parts;

      if (this.companyData?.location) {
        return [this.companyData.location];
      }

      return ['Not set'];
    }
  },

  watch: {

    all_section: {
      immediate: true,
      handler(newVal) {
        if (newVal.length > 0 && this.companyData) {
          this.initialize_company_answers();
        }

      },

    },
    is_dropin_selected(newValue) {
      if (newValue === true) {
        this.$nextTick(() => {
          this.get_autocomplete_location(this.$refs.addItemLocationInput, (address) => {
            this.item_form.service_location = address;
            if (this.errors) {
              this.errors.service_location = null;
            }
          });

        });
      }
    },
    service_types: {
      handler(new_type) {
        if (new_type && new_type.length > 0 && !this.item_form.service_type_id) {
          const drop_in_type = new_type.find(t => t.name.toLowerCase() === 'drop_in');
          if (drop_in_type) {
            this.item_form.service_type_id = drop_in_type.id;
          }
        }
      },
      deep: true,
      immediate: true
    }

  },

  mounted() {
    this.user_id = this.$route.query.user_id
    this.fetch_type_of_profile();
    this.fetch_social_types()
    this.fetch_product_types()
    this.base_profile_id = this.$route.query.base || get_id_from_profile_slug(this.$route.params.profile_slug);
    this.profile_slug = this.$route.query.profile || '';
    this.profile_type = this.$route.query.type || '';
    this.user_details = get_user_details();
    this.token_exists = get_token();
    this.get_attribute_types();

    this.filter_membership_payment_history();
    this.fetch_type_of_organization();
    this.fetch_library_resources();

    if (this.client_features.show_marketplace) {
      this.marketplace = true;
      this.show_catalogue = true;
      this.activeTab = 'catalogue';
    }

    if (this.base_profile_id || this.profile_slug) {


      this.fetch_company_profile();

    } else {
      this.fetchProfiles()
      if (this.client_features.show_business_profile) {
        this.fetch_company_profile();
        this.fetch_profile_products();

      }
    }

    const tabs = document.querySelectorAll('[data-bs-toggle="tab"]');

    tabs.forEach(tab => {
      tab.addEventListener('shown.bs.tab', () => {
        // Hide catalogue when switching to any other tab
        this.show_catalogue = false;
      });
    });

    if (this.$route.query.tab === 'catalogue') {
      setTimeout(() => {
        this.go_to_catalogue();
      }, 300);
    }

    this._realtime_report_handler = (realtime_event) =>
      this.handle_realtime_report(realtime_event);
    window.addEventListener("realtime:report", this._realtime_report_handler);


  },
  beforeUnmount() {
    if (this._realtime_report_handler) {
      window.removeEventListener("realtime:report", this._realtime_report_handler);
      this._realtime_report_handler = null;
    }
  },
  data() {
    return ({
      likedReports: {},
      profile_tabs: [],
      profile_id: null,
      library_resources: [],
      is_owner_view: false,
      fully_answered_sections: {},
      personal_profiles: [],
      question_page: 1,
      questions_per_page: 5,
      email: '',
      phone_number: '',
      profile_type_id: null,
      fileType: '',
      isLocalFile: false,
      local_file_url: null,
      latitude: null,
      longitude: null,
      rating: 0,
      total_ratings: 0,
      is_loading_products: false,
      image_view_url: null,
      user_details: {
        "user_role": '',
        "user_id": null,

      },
      activeTab: 'about',
      token_exists: true,
      isLoading: false,
      profile: {},
      errors: {},
      showPreview: false,
      file_name: '',
      user_id: '',
      membership_payment_history: [],
      userHasPaid: false,
      membership_name: '',
      company_name: '',
      type_of_organization: '',
      description: '',
      tell_number: '',
      location: '',
      selected_type_of_organization: '',
      type_of_profile: [],
      base_profiles: [],
      reports: [],
      isBusinessProfile: false,
      companyData: null,
      profile_questions: [],
      base_profile_id: null,
      profile_slug: '',
      profile_type: '',
      payload: {},
      currentPage: 1,
      reportsPerPage: 10,
      expandedReports: [],
      report_data: {},
      comment_modal_visible: false,
      edit_documents: {},
      report_name: '',
      report_description: '',
      report_id: null,
      upload_media: null,
      audio_file: null,
      audio_file_name: '',
      team_members: [],
      last_name: '',
      first_name: '',
      member_role: '',
      pitchdecks: [],
      fileError: '',
      fileName: '',
      edit_member_id: null,
      edit_pitchdeck_id: null,
      pitch_description: '',
      temporaryPost: null,
      social_platforms: [],
      catalogueTab: 'products',
      sidebarTab: 'orders',
      orders: [],
      service_types: [],
      requests: [],
      new_socials: [
        { platform: '', url: '' }
      ],
      currentField: '',
      currentVisibility: true,
      showVisibilityModal: false,
      cbo_domain: false,
      visible_domain: false,
      profilePicture: null,
      profile_picture_preview: null,
      modal_likes: [],
      cover_picture: null,
      galleryMedia: [],
      selectedGalleryItem: null,
      selectedVideoUrl: null,
      followers_list: [],
      loading_followers: false,
      type_of_followers: true,
      currentAnswerVisibility: true,
      answer_file_name: '',
      comment: '',
      user_has_rated: false,
      all_ratings: [],
      new_rating: 0,
      hover_rating: 0,
      new_review_text: '',
      start_distribution: {},
      editing: false,
      active_comment_report_id: null,
      comments_off: true,
      item_form: {
        name: '',
        price: null,
        description: '',
        service_type: null,
        service_location: '',
        attributes: {}

      },
      update_item_form: {
        product_id: '',
        name: '',
        price: null,
        description: '',
        subcategory_id: '',
        attributes: {}

      },
      modalType: '',
      product_type_id: null,
      isDragging: false,
      upload_files: [],   // actual File objects
      previews: [],       // preview objects {type, src, name, extension}
      active_profile: '',
      modal_product: '',
      isEditing: false,
      adding_to_cart: null,
      added_to_cart: null,
      product_types: [],
      is_deleting: false,
      show_catalogue: false,
      categories: [],
      subcategories: [],
      selected_category: "",
      selected_subcategory: "",
      catalogue_products: [], // ADD THIS HERE
      catalogue_services: [],
      selected_product: null,
      active_image_index: 0,
      product_reviews: [],
      product_review_text: '',
      user_has_rated_product: false,
      marketplace: false,
      service_request: {
        message: '',
        email: '',
        contact_number: '',
        date: '',
        product_id: null
      },
      attributeTypes: [],
      new_attribute_value: {},
      show_mobile_owner: false,
      show_mobile_socials: false,
    });
  },
  methods: {
      handle_realtime_report(realtime_event) {
        handle_report_realtime(this, realtime_event);
      },
      get_attribute_types() {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_attribute_types/`,
          type: 'GET',
          headers: {
            Authorization: `Token ${get_token()}`,
            'Content-Type': 'application/json',
          },
          success: (response) => {
            if (response.status === 'success') {
              this.attributeTypes = response.data;
            }
          },
        });
      },

    get_autocomplete_location(inputElement, onAddressSelected) {
      // 1. Check if Google is loaded
      if (typeof window.google === 'undefined' || !window.google.maps) {
        console.warn("Google Maps not loaded yet.");
        return;
      }


      // 2. Validate that the element actually exists before proceeding
      if (!inputElement) return;

      // 3. Attach the Autocomplete tool
      const autocomplete = new window.google.maps.places.Autocomplete(inputElement, {
        types: ['address']
      });

      // 4. When an address is clicked, send it back via the callback
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (place && place.formatted_address) {
          onAddressSelected(place.formatted_address);
        }
      });
    },
    get_rating() {
      this.isLoading = true;
      const profileId = this.companyData?.base_profile?.id;

      if (!profileId) {
        this.isLoading = false;
        return;
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_profile_rating/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({ profile_id: profileId }),
        success: (response) => {
          if (response.status === 'success') {
            this.rating = response.data.average_rating;
            this.total_ratings = response.data.total_count;

            // This is the direct array for both the Modal and the Tab
            this.all_ratings = response.data.ratings;
            this.all_ratings = this.all_ratings.map(item => ({
              ...item, expanded: false,
              show_replies: false,
              reply_draft: '',
              replies: item.replies || []
            }))
            // Check if user has already rated
            this.user_has_rated = this.all_ratings.some(r =>
              String(r.rater?.id) === String(this.active_profile_data.id)
            );

            // Update the progress bars (5 star, 4 star, etc.)
            this.calculate_distribution();
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    open_product_modal(product) {
      this.selected_product = product
      this.active_image_index = 0
      this.review_selected = 0
      this.review_hovered = 0
      this.review_comment = ''
      this.review_submitted = false
      this.product_reviews = product.reviews || []  // swap with your API field

      $('#product_details_modal').modal('show')

    },

    view_product_details(product) {
      view_profile_product(this.$router, product);
    },

    go_to_image(index) {
      this.active_image_index = index
      $('#product_image_carousel').carousel(index)
    },
    calculate_distribution() {
      const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      this.all_ratings.forEach(r => {
        if (counts[r.rating] !== undefined) counts[r.rating]++;
      });

      this.start_distribution = {
        5: this.total_ratings ? Math.round((counts[5] / this.total_ratings) * 100) : 0,
        4: this.total_ratings ? Math.round((counts[4] / this.total_ratings) * 100) : 0,
        3: this.total_ratings ? Math.round((counts[3] / this.total_ratings) * 100) : 0,
        2: this.total_ratings ? Math.round((counts[2] / this.total_ratings) * 100) : 0,
        1: this.total_ratings ? Math.round((counts[1] / this.total_ratings) * 100) : 0,
      };
    },
    format_date(datestr) {
      const date = new Date(datestr);
      const day = date.getDate();

      // Calculate the ordinal suffix (st, nd, rd, th)
      const suffix = (d => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      })(day);

      // Get the textual representations
      const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
      const month = date.toLocaleDateString('en-US', { month: 'long' }); // Added Month
      const year = date.getFullYear(); // Added Year

      // Returns format: "Monday, March 16th, 2026"
      return `${weekday}, ${month} ${day}${suffix}, ${year}`;
    },
    display_price(product) {
      return product?.final_price ?? product?.price ?? 0;
    },
    format_price(price) {
      return Number(price || 0).toLocaleString('en-ZA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    open_edit_reviews(item) {
      this.new_rating = item.rating;
      this.new_review_text = item.comment;
      this.all_ratings = this.all_ratings.filter(r => r.id !== item.id);
      this.user_has_rated = false;
      this.$nextTick(() => {
        $('#reviews-tab').tab('show');
      });
    },
    add_social_row() {
      this.new_socials.push({ platform: '', url: '' });
    },

    remove_row(index) {
      this.new_socials.splice(index, 1);
    },
    set_modal_type(type) {
      this.modalType = type;
      if (type === 'product') {
        this.product_type_id = this.product_types.find(
          (product_type) => product_type.name.toUpperCase() === type.toUpperCase()
        );
      }
      if (type === 'service') {
        this.product_type_id = this.product_types.find(
          (product_type) => product_type.name.toUpperCase() === type.toUpperCase()
        );
      }
    },
    update_request(request, type, reason = '') {
      const base_url = `${window.location.origin}/my_orders`;
      const payload = {
        request_id: request.id,
        action: type,
        return_message: reason || '',
        base_url: base_url,
      };

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_service_request_status/`,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: JSON.stringify(append_active_organization_id(payload)),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success") {

            Swal.fire({
              title: 'Success',
              text: 'Request updated successfully!',
              icon: 'success',
              timer: 1200,
              showConfirmButton: false
            });
            this.get_requests();
          }
        },
        error: (xhr) => {
          if (xhr.responseJSON && xhr.responseJSON.errors) {
            this.errors = xhr.responseJSON.errors;
          }
        }
      });

    },

    get_requests() {

      const payload = {
        profile_id: this.companyData?.base_profile?.id || this.base_profile_id
      };

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_service_requests/`,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: JSON.stringify(payload),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success") {
            this.requests = response.data;
          }
        },
        error: (xhr) => {
          if (xhr.responseJSON && xhr.responseJSON.errors) {
            this.errors = xhr.responseJSON.errors;
          }
        }
      });

    },

    get_orders() {

      const payload = {
        base_profile_id: this.companyData?.base_profile?.id || this.base_profile_id
      };

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_orders/`,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: JSON.stringify(payload),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success") {
            this.orders = response.data;
          }
        },
        error: (xhr) => {
          if (xhr.responseJSON && xhr.responseJSON.errors) {
            this.errors = xhr.responseJSON.errors;
          }
        }
      });

    },

    view_all_orders() {
      this.$router.push({ name: 'orders', query: { base_profile_id: this.companyData?.base_profile?.id || this.base_profile_id } })
    },
    save_social_profiles() {
      // 1. Filter out any rows where the user didn't select a platform or enter a URL
      const valid_link = this.new_socials.filter(link => link.platform && link.url.trim() !== '');
      if (valid_link.length === 0) {
        this.errors.social_link = 'Please enter at least one valid social link.';
        return;
      }

      const formatted_profiles = valid_link.map(link => ({
        social_type_id: link.platform,
        social_link: link.url
      }));

      const payload = {
        base_profile_id: this.base_profile_id,
        social_profiles: formatted_profiles
      };

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_social_profile/`,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: JSON.stringify(payload),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success") {
            const saved_profiles = Array.isArray(response.data) ? response.data : [response.data];
            if (!this.companyData?.social_profiles) {
              this.companyData.social_profiles = [];
            }

            saved_profiles.forEach(saved_link => {
              const existing_index = this.companyData.social_profiles.findIndex(
                (link) => link.id === saved_link.id || link.social_type?.id === saved_link.social_type?.id);

              if (existing_index !== -1) {
                this.companyData.social_profiles.splice(existing_index, 1, saved_link);
              } else {
                this.companyData.social_profiles.push(saved_link);
              }
            });

            // Reset the form back to a single empty row
            this.new_socials = [{ platform: '', url: '' }];

            $('#social_modal').modal('hide');
          }
        },
        error: (error) => {
          console.error("Error saving social links:", error.responseJSON?.message || error);
        }
      });
    },
    get_percentage(star) {
      if (!this.start_distribution) return 0;
      const entry = Object.entries(this.start_distribution)
        .map(([key, value]) => ({ star: Number(key), value }))
        .find(q => q.star === star);

      return entry ? entry.value : 0;
    },
    get_active_profile_picture(item) {
      const base = item?.base_profile || item;
      if (!base) return null;

      if (base.profile_type === 'personal') {
        return this.get_personal_logo(base);
      }

      if (base.profile_type === 'business') {
        return this.get_business_logo(base);
      }

      return null;
    },

    get_personal_logo(base) {
      const files = base.user?.profile?.profile_files;
      if (!files) return null;

      const pic = files.find(f => f.profile_file_type === 'profile_picture');
      return pic?.file?.url || null;
    },

    get_business_logo(base) {
      const files = base.company?.base_profile?.profile_files;
      if (!files) return null;

      const logo = files[0]?.file;
      return logo?.file_url || logo?.url || null;
    },

    set_active_profile_tab(tab_name) {
      this.activeTab = tab_name;
      this.show_catalogue = false;
    },
    go_to_catalogue() {
      // Hide other tab panes
      const activeTabs = document.querySelectorAll('.tab-pane.show.active');
      activeTabs.forEach(tab => {
        tab.classList.remove('show', 'active');
      });

      // Deactivate all tab buttons
      const tabButtons = document.querySelectorAll('[data-bs-toggle="tab"]');
      tabButtons.forEach(btn => btn.classList.remove('active'));
      this.activeTab = 'catalogue';
      this.show_catalogue = true;     // show Catalogue
    },

    scroll_catalogue_Tabs(direction) {
      const el = this.$refs.tabsCatalogue
      if (!el) return

      el.scrollBy({
        left: direction === 'right' ? 160 : -160,
        behavior: 'smooth'
      })
    },
    scroll_tabs(direction) {
      const el = this.$refs.tabsContainer
      if (!el) return

      el.scrollBy({
        left: direction === 'right' ? 160 : -160,
        behavior: 'smooth'
      })
    },
    submit_rating() {
      // Logic to handle if called from Tab (new_rating) or Modal (userRating)
      const final_rating = this.new_rating || this.userRating;
      const final_comment = this.new_review_text || this.comment;

      if (!final_rating) return;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_profile_rating/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          user_id: this.companyData.base_profile?.id,
          rating: final_rating,
          comment: final_comment,
        }),
        success: (response) => {
          if (response.status === 'success') {
            // Reset all inputs
            this.new_rating = 0;
            this.userRating = 0;
            this.new_review_text = '';
            this.comment = '';

            // Refresh the list
            this.get_rating();

            // Close modal if open
            $('#ratings-modal').modal('hide');
          }
        }
      });
    },

    submit_product_review() {
      if (!this.new_rating || !this.product_review_text.trim()) return

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_product_review/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          product_id: this.selected_product.id,
          rating: this.new_rating,
          review: this.product_review_text,
        }),
        success: (response) => {
          if (response.status === 'success') {
            this.selected_product.user_has_rated_product = true;
            this.user_has_rated_product = true;
            if (response.data && response.data.product_rating) {
              this.product_reviews.unshift(response.data.product_rating);
            }

            if (response.data && response.data.average_rating) {
              this.selected_product.average_rating = response.data.average_rating;
            }

            this.new_rating = 0;
            this.hover_rating = 0;
            this.product_review_text = '';
            Swal.fire({
              icon: 'success',
              title: 'Review Submitted',
              text: 'Thank you for your feedback!',
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    delete_review(item) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/delete_profile_rating/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          rating_id: item.id,
        }),
        success: (response) => {
          if (response.status === 'success') {
            this.get_rating()
          }
        }
      });
    },
    submit_reply(item) {

      if (!item.reply_draft.trim()) return

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_rating_reply/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          comment_id: item.id,
          comment: item.reply_draft,
        }),
        success: (response) => {
          if (response.status === 'success') {
            this.get_rating()
          }
        }
      });
    },

    handle_drop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        // Create a mock event to reuse your existing handleGroupFileUpload logic
        const mockEvent = { target: { files: files } };
        this.handleImagesUpload(mockEvent);
      }
    },

    same_profile() {
      return this.companyData?.base_profile?.creater?.id == this.user_details.user_id
    },
    view_rater_profile(user_id) {
      view_profile_helper(this.$router, { id: user_id });

    },
    view_company(item) {
      view_profile_helper(this.$router, item?.company);

    },

    triggerFileUploadCover() {
      this.$refs.fileInputCover && this.$refs.fileInputCover.click();
    },

    triggerProfileFileUpload() {
      this.$refs.profileFileInput && this.$refs.profileFileInput.click();
    },
    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },
    open_gallery_media(item) {
      this.selectedGalleryItem = item;
      $('#gallery_media_view_modal').modal('show');
    },

    close_gallery_media() {
      this.selectedGalleryItem = null;
      const video = document.getElementById('gallery_video_player_modal');
      if (video) {
        video.pause();
        video.src = "";
      }
      $('#gallery_media_view_modal').modal('hide');
    },


    getFileIcon(fileUrl) {
      const iconMap = [
        { extensions: ['.pdf'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337946.png' },
        { extensions: ['.doc', '.docx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337932.png' },
        { extensions: ['.xls', '.xlsx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337958.png' },
        { extensions: ['.ppt', '.pptx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337950.png' },
        { extensions: ['.html', '.htm'], icon: 'https://cdn-icons-png.flaticon.com/128/732/732212.png' },
      ];

      for (const { extensions, icon } of iconMap) {
        if (extensions.some(ext => fileUrl.includes(ext))) {
          return icon;
        }
      }

      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
    },
    isInLibrary(fileId) {
      // Return true if the file exists in the user's library
      return this.library_resources.some(
        (doc) => doc.report_file?.file?.id === fileId
      );
    },
    open_likes_modal(like_users) {
      this.modal_likes = like_users;
    },
    has_answer_for_question(q) {
      if (!this.companyData || !Array.isArray(this.companyData.answers)) return false;
      return this.companyData.answers.some(ans => {
        return ans.question && q.question && ans.question.id === q.question.id && ans.answer;
      });
    },
    onProfilePictureChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.profilePicture = file;
        this.profile_picture_preview = URL.createObjectURL(file);

        $('#image_view_modal').modal('show');
      }
    },
    onCoverPictureChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.profilePicture = file;
        this.profile_picture_preview = URL.createObjectURL(file);
        $('#image_view_cover').modal('hide');

        $('#cover_picture_modal').modal('show');
      }
    },
    fetch_social_types() {
      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_social_types/`,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            this.social_platforms = response.data
          }
        },
        error: (error) => {
          console.error("Error fetching social types:", error);
        }
      });
    },
    fetch_product_types() {
      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_product_types/`,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            this.product_types = response.data
            this.service_types = response.service_data
          }
        },
        error: (error) => {
          console.error("Error fetching social types:", error);
        }
      });
    },
    fetch_library_resources() {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_library_documents/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ user_id: this.user_details?.user_id }),
        success: (response) => {
          if (response.status === "success") {
            this.library_resources = response.data;
          }
        }
      });
    },
    follow_profile(base_profile_id) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/follow_profile/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ target_base_profile_id: base_profile_id }),
        success: (response) => {
          if (response.status === "success") {
            this.companyData.is_following = response.is_following;
          }
        }
      });
    },
    get_followers(type) {
      this.isloading_followers = true;
      let target_base_profile_id;
      let base_profile_id;
      if (type == "followers") {
        this.type_of_followers = true
        target_base_profile_id = this.companyData?.base_profile?.id;
      } else if (type == "following") {
        this.type_of_followers = false

        base_profile_id = this.companyData?.base_profile?.id;
      }


      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_followers/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          target_base_profile_id: target_base_profile_id,
          base_profile_id: base_profile_id
        }),
        success: (response) => {
          if (response.status === 'success') {
            this.followers_list = response.data.followers;
            this.followerCount = response.data.follower_count;

            // Open the modal after successful fetch
            $('#follower_modal').modal('show')

          }
        },
        error: (xhr) => {
          console.error('Error fetching followers:', xhr.responseJSON?.message || xhr.statusText);
        },
        complete: () => {
          this.isloading_followers = false;
        },
      });
    },
    fetchCompanyMedia() {
      const payload = {
        base_profile_id: this.companyData?.base_profile?.id || this.base_profile_id
      };

      const mediaExtensions = {
        images: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'avif'],
        videos: ['mp4', 'webm', 'ogg', 'mov', 'm4v', 'avi']
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile_media/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            const media_items = response.data.media || [];
            const fetchedMedia = media_items
              .filter(item => item.type === 'file')
              .map(item => {
                const url = item.file?.url || "";
                const extension = url.split('.').pop().toLowerCase().split('?')[0];
                const type = mediaExtensions.videos.includes(extension) ? 'video' :
                  mediaExtensions.images.includes(extension) ? 'image' : null;

                if (!type) return null; // Filter out documents and other files

                return {
                  id: item.id,
                  type: type,
                  url: url,
                  name: item.file?.name || this.getFileName(url),
                  poster: url
                };
              })
              .filter(item => item !== null);

            this.galleryMedia = [...fetchedMedia];
          }
        },
        error: (error) => {
          console.error("Error fetching company media:", error);
        }
      });
    },
    upload_profile_picture(file_type) {
      const formData = new FormData();
      if (this.profilePicture && this.profilePicture instanceof File) {
        formData.append('file', this.profilePicture);
        formData.append('company_id', this.companyData?.id)
      }

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we upload your profile picture.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Dynamically set the endpoint based on file_type
      let endpoint = '';
      let modalId = '';
      if (file_type === 'logo') {
        endpoint = `${process.env.VUE_APP_BACKEND_API_URL}/company_management/upload_company_logo/`;
        modalId = '#image_view_modal';
      } else if (file_type === 'cover_picture') {
        endpoint = `${process.env.VUE_APP_BACKEND_API_URL}/company_management/upload_company_cover/`;
        modalId = '#cover_picture_modal';
      } else {
        console.error('Invalid file_type provided.');
        Swal.fire('Upload Failed', 'Invalid file type specified.', 'error');
        return;
      }

      $.ajax({
        url: endpoint,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          this.profile_picture_preview = response?.data?.[0]?.file?.s3_url || null;
          this.profilePicture = null;

          Swal.fire({
            title: 'Upload Successful',
            text: 'Your company picture has been uploaded successfully.',
            icon: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(() => {
            this.fetch_company_profile();
            $(modalId).modal('hide');

            this.$emit('company_profile_updated');
          });
        },
        error: (xhr, status, error) => {
          console.error('Error uploading profile picture:', error);
          Swal.fire('Upload Failed', 'An error occurred while uploading the profile picture.', 'error');
        }
      });
    },
    delete_cover_image(file_type) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (!result.isConfirmed) return;


        const payload = {
          company_id: this.companyData?.id,
          file_type: file_type
        };

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_profile_image/`,
          method: "POST",
          data: JSON.stringify(payload),
          headers: {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          },
          success: () => {
            // Refresh company profile data
            this.fetch_company_profile();
            // Close the modal
            $('#image_preview_modal').modal('hide');
            $('#cover_picture_modal').modal('hide');

          },
          error: (err) => {
            console.error("Error deleting cover image:", err);
          }
        });
      });
    },
    displayedDescription(report) {
      if (!report.description) return '';
      // Clean description by removing the report link if present
      let cleanDesc = report.description;
      if (report.report_link && report.linkPreview) {
        cleanDesc = cleanDesc.split(report.report_link).join("").trim();
      }
      return cleanDesc;
    },
    is_image_file(url) {
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
    },
    is_pdf_file(url) {
      return /\.pdf$/i.test(url);
    },
    is_office_file(url) {
      return /\.(doc|docx|xls|xlsx|ppt|pptx)$/i.test(url);
    },
    triggerFileInput(qa) {
      const fileInput = this.$refs[`fileInput_${qa.question.id}`];
      if (fileInput) {
        // Vue 3 sometimes returns array of refs if inside v-for
        Array.isArray(fileInput) ? fileInput[0].click() : fileInput.click();
      }
    },

    onFileSelect(qa, event) {
      const file = event.target.files[0];
      if (!file) return;

      // Save selected file
      qa.newFile = file;
      qa.isChanged = true;
    },
    open_file_answer_viewer(url, name) {
      if (!url) return;
      this.answer_file_name = name;
      this.image_view_url = url;
      $('#view_answer_modal').modal('show');
    },

    open_image_viewer(url) {
      if (!url) return;
      this.image_view_url = url;
      $('#cover_picture_modal').modal('show');
    },

    open_profile_image_viewer(url) {
      if (!url) return;
      this.image_view_url = url;
      $('#image_preview_modal').modal('show');
    },

    is_section_fully_answered(section) {
      return section?.section?.question_sections?.every(qa => {
        if (!qa.question?.is_mandatory) return true;

        const value = qa.newAnswer ?? qa.answer;

        if (Array.isArray(value)) {
          return value.some(v => v !== null && v !== undefined && v !== "");
        }

        return value !== null && value !== undefined && value.toString().trim() !== "";
      });
    },

    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user_id) {

        this.user_id = this.companyData?.base_profile?.creater;
      }

      const payload = {
        filter_values: {
          user_id: this.user_id,

        }
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_user_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify(payload),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : { "Content-Type": "application/json" },
        success: (response) => {
          this.membership_payment_history = response.data.payment_history;

          this.userHasPaid = this.membership_payment_history.some(
            (payment) => payment.payment_status?.status === "paid"
          );
          this.membership_name = this.membership_payment_history[0]?.membership?.name || '';

        },
        complete: () => {
          this.isLoading = false;
        },
      })
    },
    toggleCheckbox(qa, optionId, isChecked) {
      if (!qa.newAnswer) {
        qa.newAnswer = Array.isArray(qa.answer) ? qa.answer.slice() : qa.answer ? qa.answer.split(',').map(opt => opt.trim()) : [];
      }

      if (isChecked) {

        if (!qa.newAnswer.includes(optionId)) {
          qa.newAnswer.push(optionId);
        }
      } else {

        const index = qa.newAnswer.indexOf(optionId);
        if (index > -1) {
          qa.newAnswer.splice(index, 1);
        }
      }
    },
    getToken() {
      return get_token();
    },




    // Handle new images for both add and edit
    handleImagesUpload(event) {
      const files = Array.from(event.target.files);
      if (!files.length) return;

      files.forEach(file => {
        // Add to the same upload_files array
        this.upload_files.push(file);

        // Create preview
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previews.push({
              type: "image",
              src: e.target.result,
              name: file.name
            });
          };
          reader.readAsDataURL(file);
        } else if (file.type.startsWith("video/")) {
          const url = URL.createObjectURL(file);
          this.previews.push({
            type: "video",
            src: url,
            name: file.name
          });
        } else {
          this.previews.push({
            type: "file",
            name: file.name,
            extension: file.name.split('.').pop().toLowerCase()
          });
        }
      });

      // Reset input
      event.target.value = "";
    },

    remove_file(index) {
      const file = Reflect.get(this.previews, index);
      if (file.id) {
        // Existing image: mark for deletion
        file._delete = true;
      } else {
        // Newly uploaded file: remove from upload_files and previews
        const fileIndex = this.upload_files.indexOf(file.file);
        if (fileIndex > -1) this.upload_files.splice(fileIndex, 1);
        this.previews.splice(index, 1);
      }
    },

    fetch_type_of_organization() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_organization = response.data.type_of_organization_data;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    fetch_type_of_profile() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_type_of_profile/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_profile = response.data.type_of_profile_data;

            this.show_questions();
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },


    fetchProfiles() {
      this.isLoading = true;
      const payload = {
        user_id: this.user_details.user_id
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profiles/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === 'success' && response.data.profiles) {
            this.base_profiles = response.data.profiles;
            const activeProfile = this.base_profiles.find(profile => profile.is_active);
            if (activeProfile) {
              this.base_profile_id = activeProfile.id;
              this.active_profile = activeProfile.id;

            }
          }
          const personalType = this.type_of_profile.find(
            (type) => type.name.toLowerCase() === 'personal'
          );

          if (personalType) {
            this.personal_profiles = this.base_profiles.filter(
              (profile) => profile.profile_type === personalType.id
            );
          } else {
            this.personal_profiles = [];
          }
          this.fetch_company_profile()
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    view_profile(companyData) {
      const creator = companyData?.base_profile?.creater || companyData?.creater || companyData?.user;
      view_profile_helper(this.$router, creator || companyData);
    },


    fetch_company_profile() {
      const payload = this.get_company_profile_payload();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_filtered_company_profile/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            this.companyData = response.data;
            this.isBusinessProfile = true;
            this.team_members = this.companyData.team_members || [];
            this.pitchdecks = this.companyData.pitch_decks || [];
            this.filterReports();
            this.profile_type_id = this.companyData?.base_profile?.profile_type;
            this.show_assigned_profile_tabs();
            this.fetchCompanyMedia();
            this.fetch_profile_products();
            this.get_requests();
            this.get_orders();
          }
        },
        error: (xhr, status, error) => {
          console.error("Error fetching company profile:", error);
          this.isBusinessProfile = false;
        },
        complete: () => {
          this.get_rating();
          this.initialize_company_answers()
        }
      });
    },
    get_company_profile_payload() {
      if (this.base_profile_id) {
        return ({ profile_id: this.base_profile_id });
      }

      return ({
        profile_slug: this.profile_slug,
        profile_type: this.profile_type || 'business',
      });
    },

    show_questions() {

      const businessProfile = this.type_of_profile.find(
        (profile) => profile.name.toLowerCase() === 'business'
      );
      const payload = {
        filter_values: {
          profile_type_id: businessProfile.id,
        },
      };
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          this.profile_questions = response.data;
        },
      });
    },
    show_assigned_profile_tabs() {

      const payload = {
        profile_type_id: this.profile_type_id,
        base_profile_id: this.companyData?.base_profile?.id || this.base_profile_id,

      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/filter_assigned_profile_tabs/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          this.profile_tabs = response.data;
        },
      });
    },
    filterReports() {
      const payload = {
        base_profile_id: this.companyData?.base_profile?.id || this.base_profile_id,

      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/filter_company_reports/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {

          const status = response.status

          if (status === "success") {
            this.reports = response.data.results || [];
            for (const report of this.reports) {
              this.likedReports[report.id] = report.likes.some(
                item => item.user.id == this.user_details.user_id
              )
            }



            setTimeout(() => {
              this.loading = false;
            }, 1000);


          }

        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    truncateDescription(description, maxLength = 25) {
      const words = description.split(/\s+/);
      if (words.length > maxLength) {
        return words.slice(0, maxLength).join(" ") + '...';
      }
      return description;
    },



    isReportExpanded(reportId) {
      return this.expandedReports.includes(reportId);
    },

    baseUrl(post, type) {
      const baseUrl = `${window.location.origin}${this.$route.path}`;

      // Dynamically build the URL based on the type (either 'hub' or 'report')
      if (type === 'exchange_hub') {
        return `${baseUrl}?hub_id=${post.id}`;
      } else if (type === 'report') {
        return `${baseUrl}?report_id=${post.id}`;
      }
      return baseUrl
    },
    copyReportLinkToClipboard(report) {
      const link = this.baseUrl(report, 'report');
      navigator.clipboard.writeText(link).then(() => {
        this.showToast('Link copied to clipboard!');
      })
    },
    showToast(message) {
      document.querySelector('#copyToast .toast-body').textContent = message;

      $('#copyToast').fadeIn(300).addClass('show');
      setTimeout(function () {
        $('#copyToast').fadeOut(300).removeClass('show');
      }, 3000);
    },
    display_comment_modal(data) {
      this.report_data = data;
      this.comment_modal_visible = true;
    },

    deleteReport(report_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'DELETE',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_report_api/`,
            data: { report_id: report_id },
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.reports = this.reports.filter(report => report.id !== report_id);
                Swal.fire({
                  title: 'Deleted!',
                  text: 'The feed has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000
                })
              }
            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to delete the feed. Please try again.',
              });
            }
          });
        }
      });
    },
    togglePinReport(report) {
      const newPinStatus = !report.is_pinned;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/pin_report_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          post_id: report.id,
          is_pinned: newPinStatus
        }),
        success: (response) => {
          if (response.status === 'success') {
            report.is_pinned = newPinStatus;

            const index = this.reports.indexOf(report);
            if (index > -1) {
              this.reports.splice(index, 1);
            }
            if (newPinStatus) {
              this.reports.unshift(report);
            } else {
              this.filterReports()
            }
          }
        },
      });
    },

    likeReport(report) {
      const reportId = report.id;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ report_id: reportId }),

        success: (response) => {
          if (response.status === "success") {
            const liked_report = this.reports.find(r => r.id === reportId);

            if (liked_report) {
              // ✅ Increment like counts
              liked_report.like_count++;
              liked_report.total_likes = (liked_report.total_likes || 0) + 1;

              // ✅ Add current user to report.likes (for modal)
              const currentUser = {
                user: {
                  id: this.user_details.user_id,
                  first_name: this.user_details.first_name,
                  last_name: this.user_details.last_name,
                  profile_picture: this.user_details.profile_picture || null,
                  is_blocked: false
                }
              };

              // Prevent duplicates
              const alreadyLiked = liked_report.likes.some(
                (u) => u.user && u.user.id === this.user_details.user_id
              );

              if (!alreadyLiked) {
                liked_report.likes.push(currentUser);
              }

              // ✅ Reassign reports array to trigger reactivity
              this.reports = [...this.reports];
            }

            // ✅ Save locally liked report IDs
            if (
              (typeof reportId === 'number' && Number.isInteger(reportId)) ||
              (typeof reportId === 'string' && /^[a-zA-Z0-9_-]+$/.test(reportId))
            ) {
              this.likedReports[report.id] = true;
            } else {
              console.warn('Invalid reportId:', reportId);
            }
          }
        }
      });
    },
    unlikeReport(report) {
      const reportId = report.id;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ report_id: reportId }),
        success: (response) => {
          if (response.status === "success") {
            const unliked_report = this.reports.find(r => r.id === reportId);
            if (unliked_report) {
              if (unliked_report.like_count > 0) {
                unliked_report.like_count--;   // update like count shown on each report
              }
              if (unliked_report.total_likes > 0) {
                unliked_report.total_likes--; // update global total likes
              }
            }

            // Validate reportId before setting
            if (
              (typeof reportId === 'number' && Number.isInteger(reportId)) ||
              (typeof reportId === 'string' && /^[a-zA-Z0-9_-]+$/.test(reportId))
            ) {
              this.likedReports[report.id] = false;
            } else {
              console.warn('Invalid reportId:', reportId);
            }
          }
        }
      });
    },

    edit_report(report) {
      this.report_name = report.name
      this.report_description = report.description;
      this.report_id = report.id
      this.edit_documents = report
      this.comments_off = report.can_comment
      this.$nextTick(() => {
        if (this.$refs.quillReportRef) {
          const quillEditor = this.$refs.quillReportRef.getQuill();
          if (quillEditor) {
            quillEditor.clipboard.dangerouslyPasteHTML(this.report_description);
          }
        }
      });
    },

    edit_report_data() {
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.isSubmitting = true;
      const formData = new FormData();
      const plainText = this.$refs.quillReportRef.getQuill().root.innerHTML.trim();
      this.report_description = plainText;
      formData.append('description', this.report_description);
      formData.append('report_id', this.report_id);
      formData.append('can_comment', this.comments_off);
      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }
      if (this.audio_file) {
        formData.append('file', this.audio_file, this.audio_file_name);
      }
      if (this.selected_topic) {
        formData.append('topic_id', this.selected_topic);
      }

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_report_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === 'success') {
            const updatedReport = response.updated_data;
            const reportIndex = this.reports.findIndex(
              (hub) => hub.id === updatedReport.id
            );

            if (reportIndex !== -1) {
              this.reports.splice(reportIndex, 1, updatedReport);
            }
            Swal.fire({
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1000
            }).then(() => {
              $('#edit_report_modal').modal('hide');
              this.resetSelection();
            });
          }
        },
        error: (response) => {
          Swal.close()
          const response_data = response.responseJSON;
          this.errors.edit_name = response_data.message
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    resetSelection() {
      this.report_name = '';
      this.report_description = '';
      this.report_id = null;
      this.edit_documents = {};

      this.upload_media = '';
      this.audio_file = null;
      this.errors = {}
    },

    resetForm() {
      this.first_name = '';
      this.last_name = '';
      this.email = '';
      this.member_role = '';
      this.edit_member_id = null;
      this.errors = {};
    },



    resetPitchdeckForm() {
      this.pitchdeckTitle = '';
      this.pitch_description = '';
      this.upload_media = null;
      this.fileName = '';
      this.fileError = '';
      this.edit_pitchdeck_id = null;
    },







    addReportToHome(newReport) {
      if (newReport) {

        newReport.total_comments = newReport.total_comments || 0;
        newReport.like_count = newReport.like_count || 0;
        if (newReport.portal.is_public === true) {
          this.reports.unshift(newReport);
        }
      }
      this.temporaryPost = null;
    },

    on_dynamic_tab_click(profile_tab) {


      const portalTabId = profile_tab.id;
      this.check_profile_tab_access_from_tab_requests(portalTabId, profile_tab);
    },
    check_profile_tab_access_from_tab_requests(profile_tab_id, profile_tab) {
      const creatorId = String(this.companyData?.base_profile?.creater?.id || this.companyData?.base_profile?.creater);
      const currentUserId = String(this.user_details.user_id);

      if (creatorId === currentUserId) {
        profile_tab.access_approved = true;
        profile_tab.access_requested = false;
        profile_tab.access_checked = true;
        profile_tab.access_rejected = false;
        return;
      }

      const active_profile = this.active_profile;
      const active_profile_id = active_profile ? (active_profile.id || active_profile) : null;
      const requests = this.companyData.tab_access_requests || [];

      // Find request for this section and this user
      const portal_tab_request = requests.find(req =>
        String(req.tab_key_id) === String(profile_tab_id) &&
        (String(req.requester) === String(active_profile_id) || String(req.requester?.id) === String(active_profile_id))
      );

      if (!portal_tab_request) {
        profile_tab.access_approved = false;
        profile_tab.access_requested = false;
      } else {
        const status = portal_tab_request.status?.toLowerCase();
        if (status === 'approved') {

          profile_tab.access_approved = true;
          profile_tab.access_requested = false;
          profile_tab.access_rejected = false;
        } else if (status === 'pending') {
          profile_tab.access_approved = false;
          profile_tab.access_requested = true;
          profile_tab.access_rejected = false;
        } else {

          profile_tab.access_approved = false;
          profile_tab.access_requested = false;
          profile_tab.access_rejected = true;
        }
      }
      profile_tab.access_checked = true;
    },
    request_tab_access(section) {
      const requestPayload = {
        target_profile_id: this.companyData.id,
        tab_key: section.id,
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/request_access_private_tab/`,
        method: 'POST',
        data: JSON.stringify(requestPayload),
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json"
        },
        success: () => {
          section.access_requested = true;
          Swal.fire({
            icon: 'success',
            title: 'Request Sent',
            text: 'Your access request has been sent. Please wait for approval.',
            timer: 2000,
            showConfirmButton: false
          });
        },
        error: (err) => {
          console.error("Access request error:", err);
        },
      });
    },



    submit_tab_form_answers(profile_tab, form_wrap) {
      this.isSubmitting = true;

      const base_profile_id = this.companyData?.base_profile?.id;
      const profile_tab_id = profile_tab.profile_tab.id;
      const form_id = form_wrap.form.id;

      // 🔹 collect ONLY questions from this form
      const all_qa = form_wrap.form.form_sections.flatMap(fs =>
        fs.section?.question_sections || []
      );

      let has_validation_error = false;

      const answers = all_qa.map(qa => {
        let combined_answer = qa.newAnswer ?? qa.answer;
        let usedCustom = false;

        // Handle "Other / Please specify"
        if (
          typeof combined_answer === "string" &&
          /\bothers?( please specify|\(please specify\))?\b/i.test(combined_answer.trim())
        ) {
          if (qa.customAnswer?.trim()) {
            usedCustom = true;
            combined_answer = qa.customAnswer.trim();
            qa.newAnswer = combined_answer;
            qa.customAnswer = "";
          }
        }

        // Normalize arrays (checkbox)
        const filtered_answer = Array.isArray(combined_answer)
          ? combined_answer.filter((v, i, self) => v && self.indexOf(v) === i)
          : combined_answer;

        const answer_value = Array.isArray(filtered_answer)
          ? filtered_answer.join(",")
          : filtered_answer;

        const string_answer =
          typeof answer_value === "string" ? answer_value.trim() : answer_value;

        // 🔴 validation
        if (qa.question?.is_mandatory) {
          const isEmpty = !string_answer;
          if (isEmpty || (usedCustom && !string_answer)) {
            qa.validation_error = "This field is required.";
            has_validation_error = true;
          } else {
            qa.validation_error = null;
          }
        } else {
          qa.validation_error = null;
        }
        return ({
          question_id: qa.question.id,
          answer: answer_value,
        });
      });

      if (has_validation_error) {
        this.isSubmitting = false;
        return;
      }

      // 🔹 FormData (future-proof for files)
      const formData = new FormData();
      formData.append("base_profile_id", base_profile_id);
      formData.append("profile_tab_id", profile_tab_id);
      formData.append("form_id", form_id);
      formData.append("answers", JSON.stringify(answers));

      // 🔹 API call
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/submit_tab_form/`,
        type: "POST",
        headers: { Authorization: `Token ${get_token()}` },
        data: formData,
        processData: false,
        contentType: false,

        success: (response) => {
          this.isSubmitting = false;

          if (response.status === "success") {
            // reset UI state
            all_qa.forEach(qa => {
              qa.isChanged = false;
              qa.validation_error = null;
            });

            Swal.fire({
              icon: "success",
              title: "Saved",
              text: "Form saved successfully"
            });

            // optional refresh
            this.fetch_company_profile();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "Failed to save form"
            });
          }
        },

        error: () => {
          this.isSubmitting = false;
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to connect to server"
          });
        }
      });
    },
    submit_all_answers() {
      this.isSubmitting = true;
      const base_profile_id = this.companyData?.base_profile?.id;

      const all_qa = this.all_section.flatMap(section =>
        section.section?.question_sections || []
      );
      let has_validation_error = false; // track validation errors

      const answers = all_qa.map(qa => {
        let combined_answers = qa.newAnswer || qa.answer;
        let usedCustom = false;

        if (
          typeof combined_answers === 'string' &&
          /\bothers?( please specify|\(please specify\))?\b/i.test(combined_answers.trim())
        ) {
          if (qa.customAnswer?.trim()) {
            usedCustom = true;

            combined_answers = qa.customAnswer.trim();
            qa.newAnswer = combined_answers;
            qa.customAnswer = "";
            qa.showCustomInput = false;
          }
        }

        const filtered_answers = Array.isArray(combined_answers)
          ? combined_answers.filter((value, index, self) => value && self.indexOf(value) === index)
          : combined_answers;

        const answer = Array.isArray(filtered_answers) ? filtered_answers.join(",") : filtered_answers;

        const string_answer = typeof answer === 'string' ? answer.trim() : answer;
        if (qa.question?.is_mandatory) {
          const is_file_question = qa.question.question_type?.question_type === "file";
          const has_file = !!qa.newFile;

          const isEmpty =
            (!string_answer || (Array.isArray(answer) && answer.length === 0)) &&
            !(is_file_question && has_file);

          if (isEmpty || (usedCustom && !string_answer)) {
            qa.validation_error = "This field is required.";
            has_validation_error = true;
          } else {
            qa.validation_error = null;
          }
        } else {
          qa.validation_error = null;
        }


        const answerObj = {
          question_id: qa.question.id,
          answer: answer,
        };

        // ✅ add file reference if exists
        if (qa.question.question_type?.question_type === 'file' && qa.newFile) {
          answerObj.file = qa.newFile;
          answerObj.answer = qa.newFile.name;
        }

        return answerObj;
      });

      if (has_validation_error) {
        this.isSubmitting = false;
        return;
      }

      const formData = new FormData();
      formData.append("base_profile_id", base_profile_id);

      // Add answers (without files) as JSON
      const answersPayload = answers.map(ans => ({
        question_id: ans.question_id,
        answer: ans.answer
      }));
      formData.append("answers", JSON.stringify(answersPayload));

      // Append files separately
      answers.forEach(ans => {
        if (ans.file) {
          formData.append(`file_${ans.question_id}`, ans.file);
        }
      });

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/answer_questions_for_base_profile/`,
        type: "POST",
        headers: { Authorization: `Token ${get_token()}` },
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          if (response.status === "success") {
            this.isSubmitting = false;

            for (const ans of answers) {
              const qa = all_qa.find(qa => qa.question.id === ans.question_id);
              const question = qa?.question;
              if (!question) continue;

              const existing = this.companyData.answers.find(a => a.question.id === ans.question_id);
              if (existing) {
                existing.answer = ans.answer;
              } else {
                this.companyData.answers.push({
                  question,
                  answer: ans.answer,
                });
              }

              // Reset UI state on success — clear customAnswer since saved in newAnswer
              if (qa) {
                qa.newAnswer = ans.answer;
                qa.customAnswer = "";
                qa.showCustomInput = false;
              }
            }

            all_qa.forEach(qa => {
              qa.isChanged = false;
              qa.isEditing = false;
              qa.validation_error = null;
            });

            this.fetch_company_profile();
          } else {
            this.isSubmitting = false;
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response.message || 'An error occurred while saving answers.',
            });
          }
        },
        error: () => {
          this.isSubmitting = false;
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to connect to the server. Please try again later.',
          });
        }
      });
    },

    initialize_company_answers() {

      this.all_section.forEach(section => {
        section.section?.question_sections?.forEach(qa => {
          const ansObj = this.companyData.answers?.find(ans => ans.question.id === qa.question.id);
          if (ansObj) {
            if (qa.question.question_type.question_type === 'checkbox') {
              qa.newAnswer = ansObj.answer ? ansObj.answer.split(',') : [];
            } else {
              qa.newAnswer = ansObj.answer || '';
            }
            qa.files = ansObj.files || [];
          } else {
            qa.newAnswer = qa.question.question_type.question_type === 'checkbox' ? [] : '';
            qa.files = [];
          }
          qa.isChanged = false;
        });
        const full = this.is_section_fully_answered(section);
        this.fully_answered_sections[section.section.id] = full;
      });
    },

    paginated_questions(questions) {
      const start = (this.question_page - 1) * this.questions_per_page;
      return questions.slice(start, start + this.questions_per_page);
    },
    total_puestion_pages(questions) {
      return Math.ceil(questions.length / this.questions_per_page);
    },
    // Helper to get current section's questions

    getAnswerByQuestionId(questionId) {
      if (!this.companyData || !this.companyData.answers) return null;
      return this.companyData.answers.find(a => a.question.id === questionId);
    },
    open_answer_visibility_modal(answerObj) {

      this.currentAnswer = answerObj;  // store answer object (including id)
      this.currentAnswerVisibility = answerObj.is_visible ?? true;

      this.showVisibilityModal = true;
      $('#answer_visibility_modal').modal('show');
    },

    filteredQuestionSections(section) {
      return section.section.question_sections.filter(q => {
        const answer = this.getAnswerByQuestionId(q.question.id);

        // Always show to owner
        if (this.isOwner) {
          return true;
        }
        if (!this.has_answer_for_question(q)) {
          return false;
        }

        return (answer?.is_visible ?? true) && !q.question?.is_locked || q.question?.is_mandatory;
      });
    },

    save_answer_visibility() {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_answer_visibility_api/`, // example endpoint
        method: 'POST',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          answer_id: this.currentAnswer.id,
          is_visible: this.currentAnswerVisibility,
        }),
        success: (response) => {
          if (response.status === 'success') {
            // Update local visibility
            this.currentAnswer.is_visible = this.currentAnswerVisibility;

            const existingAnswer = this.companyData.answers.find(ans => ans.id === this.currentAnswer.id);
            if (existingAnswer) {
              existingAnswer.is_visible = this.currentAnswerVisibility;
            }

            this.showVisibilityModal = false;
            $('#answer_visibility_modal').modal('hide');
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    },

    open_company_visibility_modal(field) {
      this.currentField = field;

      const visibilityArray = Object.entries(this.companyData.visibility || {}).map(
        ([field, value]) => ({ field, value })
      );
      const setting = visibilityArray.find(s => s.field === field);

      this.currentVisibility = setting ? setting.value : false;

      this.showVisibilityModal = true;
      $('#visibility_modal').modal('show');
    },

    save_company_visibility() {
      const updatedVisibility = {
        ...this.companyData.visibility,
        [this.currentField]: this.currentVisibility,
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_company_visibility/`,
        method: 'POST',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          company_id: this.companyData.id,
          visibility: updatedVisibility,
        }),
        success: (response) => {
          if (response.status === 'success') {
            this.companyData.visibility = updatedVisibility;
            this.showVisibilityModal = false;
            $('#visibility_modal').modal('hide');
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    },
    async submit_comment(report_id) {
      const comment_text = $("#comment_text_area").val();

      if (comment_text.trim() === "") {
        Swal.fire({
          icon: 'error',
          title: 'Please write a comment before submitting.',
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      const baseUrl = `${window.location.origin}${this.$route.path}?report_id=${report_id}`;
      this.commentText = "";
      $("#comment_text_area").val("");

      const request_data = {
        report_id,
        comment_text,
        base_url: baseUrl
      };

      const request_url = `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_comment/`;

      $.ajax({
        url: request_url,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(request_data),
        success: (response) => {
          if (response.status === "success") {
            const newComment = response.data.comment_data;

            // ✅ Find the report in parent state
            const reportIndex = this.reports.findIndex(r => r.id === report_id);
            const report = this.reports.at(reportIndex); // safer access

            if (report) {
              // ✅ Replace comments array so Vue notices the change
              report.comments = [newComment].concat(report.comments);

              // ✅ Increment total_comments
              report.total_comments = (report.total_comments || 0) + 1;

              // ✅ Replace parent reports array for top-level reactivity
              this.reports = Array.from(this.reports);
            }

            // Clear input
            this.commentText = "";
            $("#comment_text_area").val("");
          }
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            title: 'Could not add comment',
            text: 'Please try again later.',
            timer: 3000,
            showConfirmButton: false,
          });
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    async approve_tab_access_request(filter_user) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/approve_tab_access_request/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          tab_id: filter_user.tab_key_id,
          target_profile_id: filter_user.target_profile,
          requester_id: filter_user.requester.id
        }),
        success: (data) => {

          if (data.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Access request approved successfully.',
              showConfirmButton: false,
              timer: 1000
            }).then(() => {
              Swal.close()

            });
            this.companyData.tab_access_requests = this.companyData.tab_access_requests.map(user =>
              user.id === filter_user.id ? { ...user, status: 'approved' } : user
            );
          }
        },
      });
    },
    async reject_tab_access_request(filter_user) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/reject_tab_access_request/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          tab_id: filter_user.tab_key_id,
          target_profile_id: filter_user.target_profile,
          requester_id: filter_user.requester.id
        }),
        success: (data) => {
          if (data.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Access request declined successfully.',
              showConfirmButton: false,
              timer: 1000
            })

            this.companyData.tab_access_requests = this.companyData.tab_access_requests.map(user =>
              user.id === filter_user.id ? { ...user, status: 'rejected' } : user
            );
          }
        },
      });
    },
    getCarouselImages(report) {
      return report.report_files.filter((item) =>
        item.file.url.includes('.jpg') ||
        item.file.url.includes('.JPG') ||
        item.file.url.includes('.png') ||
        item.file.url.includes('.PNG') ||
        item.file.url.includes('.avif') ||
        item.file.url.includes('.AVIF') ||
        item.file.url.includes('.jpeg') ||
        item.file.url.includes('.JPEG') ||
        item.file.url.includes('.webp') ||
        item.file.url.includes('.WEBP')
      )
    },

    reset_product_form() {
      // Clear text inputs / bound form fields
      this.item_form.name = '';
      this.item_form.price = '';
      this.item_form.service_type_id = null;
      this.item_form.description = '';
      this.item_form.attributes = {};
      this.update_item_form.product_id = '';
      this.update_item_form.name = '';
      this.update_item_form.price = '';
      this.update_item_form.description = '';
      this.update_item_form.subcategory_id = '';
      this.isEditing = false;
      this.product_type_id = null;
      // Clear category dropdowns
      this.selected_category = '';
      this.selected_subcategory = '';
      this.subcategories = [];
      // Clear file uploads
      this.upload_files = [];
      this.previews = [];
      this.isLoading = false;
      this.new_attribute_value = {};
    },


    cancel_edit() {
      this.isEditing = false;
      this.reset_product_form();
    },
    close_add_item_modal() {
      // 1️⃣ Reset the form first
      this.reset_product_form();

      // 2️⃣ Close the modal using jQuery
      $('#productModal').modal('hide'); // jQuery hides the modal
    },

    validate_item_form() {

      let hasError = false;

      // Name required
      if (!this.item_form.name || !this.item_form.name.trim()) {
        this.errors.name = "Product name is required";
        hasError = true;
      }
      // Price required and must be positive
      if (this.item_form.price === '' || this.item_form.price === null) {
        this.errors.price = "Product price is required";
        hasError = true;
      } else if (Number(this.item_form.price) <= 0) {
        this.errors.price = "Price must be greater than 0";
        hasError = true;
      }
      if (this.modalType === 'service') {
        if (!this.item_form.service_type_id) {
          this.errors.service_type = "Please select a service type (Drop-In or Field Service)";
          hasError = true;
        }
        if (this.is_dropin_selected && !this.item_form.service_location?.trim()) {
          this.errors.service_location = "Location is required for drop-in services";
          hasError = true;
        }
      }
      return hasError;
    },
    open_manage_modal(product) {
      // Set the modal product
      this.modal_product = product;
      $('#manageProductModal').modal('show');
    },
    open_product_promo_code_manager(product) {
      if (!product?.id) return;
      this.modal_product = product;
      $('#manageProductModal').modal('hide');
      this.$nextTick(() => {
        this.$refs.productPromoCodeRef?.open_product_promo_code_manager_modal?.(product);
      });
    },
    open_catalogue_promo_code_manager() {
      const products = (this.catalogue_products || []).filter(
        (product) => product?.id && String(product?.product_type?.name || "").toLowerCase() !== "service",
      );
      if (!products.length) return;

      this.$nextTick(() => {
        this.$refs.productPromoCodeRef?.open_catalogue_promo_code_manager_modal?.({
          products,
          base_profile_id: this.companyData?.base_profile?.id || this.base_profile_id,
        });
      });
    },
    update_parent_product_promos(payload) {
      const product_id = String(payload?.product_id || this.modal_product?.id || "");
      const promo = payload?.promo;
      if (!product_id || !promo) return;

      const product = (this.profile_products || []).find(
        (item) => String(item.id) === product_id,
      ) || this.modal_product;
      if (!product) return;

      const currentPromos = product.product_promo_codes || product.promo_codes || [];
      const promoIndex = currentPromos.findIndex(
        (item) => String(item.id) === String(promo.id),
      );

      if (promoIndex === -1) {
        currentPromos.unshift(promo);
      } else {
        currentPromos.splice(promoIndex, 1, promo);
      }

      if (this.$set) {
        this.$set(product, "product_promo_codes", currentPromos);
      } else {
        product.product_promo_codes = currentPromos;
      }
      if (String(this.modal_product?.id) === product_id) {
        this.modal_product = product;
      }
    },
    handle_parent_product_promo_deletion(payload) {
      const product_id = String(payload?.product_id || this.modal_product?.id || "");
      const promo_id = String(payload?.promo_id || "");
      if (!product_id || !promo_id) return;

      const product = (this.profile_products || []).find(
        (item) => String(item.id) === product_id,
      ) || this.modal_product;
      if (!product) return;

      const currentPromos = product.product_promo_codes || product.promo_codes || [];
      product.product_promo_codes = currentPromos.filter(
        (promo) => String(promo.id) !== promo_id,
      );
      if (String(this.modal_product?.id) === product_id) {
        this.modal_product = product;
      }
    },

    async create_product() {
      this.errors = {}
      if (this.validate_item_form()) {
        return;
      }

      this.isLoading = true; // start loader

      const base_profile_id = this.companyData?.base_profile?.id || this.base_profile_id;
      try {
        const response = await create_catalogue_item({
          item_form: this.item_form,
          base_profile_id,
          organization_id: this.get_create_product_organization_id(),
          product_type_id: this.product_type_id?.id,
          selected_subcategory: this.selected_subcategory,
          upload_files: this.upload_files,
          token: this.getToken(),
        });

        if (response.status === "success") {
          const newProduct = response.data;
          if (newProduct.product_type.name === 'service') {
            this.catalogue_services.push(newProduct)
          }
          else if (newProduct.product_type.name !== 'service') {

            this.catalogue_products.push(newProduct)
          }

          this.reset_product_form();
          $('#addItemModal').modal('hide');

          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Item uploaded successfully!',
            showConfirmButton: false,
            timer: 1000
          });
        }
      } catch (xhr) {
        console.error('Upload failed:', xhr.responseText)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: xhr.responseText,
        })
      } finally {
        this.isLoading = false; // stop loader
      }

    },

    get_create_product_organization_id() {
      if (!this.client_features?.show_organisation) return '';
      return get_active_organization_id() || '';
    },

    fetch_profile_products() {
      const base_profile_id = this.companyData?.base_profile?.id || this.base_profile_id;
      const user_id = this.user_details.user_id;
      this.is_loading_products = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profile_products/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          base_profile: base_profile_id,
          user_id: user_id
        }),
        success: (response) => {
          if (response.status === "success") {
            this.profile_products = response.data;
            this.profile_products.forEach(product => {
              product.user_has_rated_product = product.reviews.some(r =>
                String(r.base_profile?.id) === String(this.active_profile_data.id)
              );

            });

            this.catalogue_products = this.profile_products.filter(p => p.product_type?.name !== 'service' || p.product_type === null);
            this.catalogue_services = this.profile_products.filter(p => p.product_type?.name === 'service');
            this.is_loading_products = false

            if (this.$route.query.product_id) {
              const product_id = String(this.$route.query.product_id);
              const product = this.profile_products.find(p => String(p.id) === product_id);
              if (product) {
                this.catalogueTab = product.product_type?.name === 'service' ? 'services' : 'products';
                setTimeout(() => {
                  this.open_product_modal(product);
                  // Remove the query string after opening, so it doesn't pop up again if they navigate tabs internally
                  const query = Object.assign({}, this.$route.query);
                  delete query.product_id;
                  this.$router.replace({ query }).catch((err) => err);
                }, 500);
              }
            }
          }
        }
      });
    },

    toggle_publish(product) {
      const previousState = product.is_published;
      product.is_published = !product.is_published;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/publish_product/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(append_active_organization_id({
          product_id: product.id,
          base_profile_id: this.base_profile_id
        })),
        success: (response) => {
          if (response.status === "success") {
            product.is_published = response.is_published;
            this.modal_product = product;
          } else {
            // Revert if something went wrong
            product.is_published = previousState;
            Swal.fire({
              icon: 'error',
              title: 'Oops!',
              text: response.message,
              confirmButtonText: 'OK'
            });
          }
        },
        error: (xhr) => {
          // Revert the published state locally
          product.is_published = previousState;
          const message = xhr.responseJSON?.message || 'Failed to update product status.';

          Swal.fire({
            icon: 'error',
            title: 'Oops!',
            text: message,
            confirmButtonText: 'OK'
          }).then(() => {
            // If the error is about dropoff, switch to Dropoff tab
            if (message.toLowerCase().includes('dropoff')) {
              this.catalogueTab = 'dropoff';
            } else {
              // Open modal anyway
              this.open_manage_modal(product);
            }
          });
        },
      });
    },

    async add_to_cart(product, base_profile) {
      this.adding_to_cart = product;
      this.added_to_cart = null;
      try {
        const response = await add_to_cart_helper({
          product_id: product,
          base_profile_id: base_profile,
          token: this.getToken(),
        });

        if (response.status === "success") {
          this.added_to_cart = product;
          this.$emit('cart_updated');
          setTimeout(() => {
            this.added_to_cart = null;
          }, 2000);
        }
      } catch (error) {
        console.error("Error adding product to cart:", error);
      } finally {
        this.adding_to_cart = null;
      }
    },

    open_service_request_modal(product) {
      this.service_request = product;
      this.service_request.product_id = product.id;
      this.service_request.email = this.user_details.email || '';
      this.service_request.contact_number = this.user_details.phone_number || '';
      this.service_request.message = '';
      this.service_request.date = new Date().toISOString().split('T')[0];
      this.$nextTick(() => {
        if (this.service_request?.service_details?.type_name === 'on_site') {
          this.get_autocomplete_location(this.$refs.serviceLocationInput, (address) => {
            this.service_request.location = address;
          });

        }
      });
      $('#serviceRequestModal').modal('show');
    },

    submit_service_request() {
      if (!this.service_request.email || !this.service_request.contact_number || !this.service_request.date) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Please fill in all fields.',
        });
        return;
      }
      const selectedDate = new Date(this.service_request.date);
      const now = new Date();


      if (!this.service_request.date) {
        this.errors.service_date = "Please select a date.";
      } else if (selectedDate < now) {
        this.errors.service_date = "You cannot request a service for a past date.";
      }

      // Check if there are any keys in the errors object
      if (Object.keys(this.errors).length > 0) {
        return; // Stop submission
      }
      let formData = new FormData();
      formData.append('message', this.service_request.message);
      formData.append('company_base_profile', this.companyData?.base_profile.id);
      formData.append('email', this.service_request.email);
      formData.append('contact_number', this.service_request.contact_number);
      formData.append('request_date', this.service_request.date);
      formData.append('product_id', this.service_request.product_id);
      formData.append('location', this.service_request.location || null);

      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/request_service/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Service request submitted successfully!',
              showConfirmButton: false,
              timer: 1500,
              allowOutsideClick: false
            }).then(() => {
              window.location = `${window.location.origin}/my_orders`;
            });
            $('#serviceRequestModal').modal('hide');
            this.service_request = {
              message: '',
              email: '',
              contact_number: '',
              date: '',
              product_id: null
            };
          } else {
            Swal.fire('Error', response.message || 'Failed to submit service request', 'error');
          }
        },
        error: (xhr) => {
          Swal.fire('Error', xhr.responseJSON?.message || 'Failed to submit service request', 'error');
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    delete_product(product) {
      // Confirm deletion with Swal
      Swal.fire({
        title: 'Are you sure?',
        text: "This will permanently delete the product!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.is_deleting = true; // start loader
          // Proceed with AJAX delete
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_product/`,
            method: 'POST',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            data: JSON.stringify({ product_id: product.id, base_profile_id: this.base_profile_id }),
            success: (response) => {
              if (response.status === "success") {
                const deleted_product = response.data;
                this.catalogue_products = this.catalogue_products.filter(
                  p => Number(p.id) !== Number(product)
                );
                this.is_deleting = false; // start loader
                $('#manageProductModal').modal('hide');

                // Show success alert
                Swal.fire({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Product has been deleted.',
                  timer: 1200,
                  showConfirmButton: false
                });
              } else {
                Swal.fire('Error', response.message || 'Failed to delete product', 'error');
              }
            },
            error: (xhr) => {
              Swal.fire('Error', xhr.responseText || 'Failed to delete product', 'error');
            }
          });
        }
      });
    }
    ,

    edit_product(product) {
      this.isEditing = true;
      this.modal_product = product;

      // Initialize form with existing data
      this.update_item_form = {
        product_id: product.id,
        name: product.name,
        price: product.price,
        description: product.description,
        subcategory_id: product.category?.id || '',
        service_type_id: product.service_details?.type_id || product.service_details?.service_type_id || '',
        location: product.service_details?.location || '',
        attributes: {}

      };
      this.selected_category = product.category || '';
      this.fetch_categories();

      // Fetch subcategories so subcategory select shows the correct value
      if (this.selected_category) {
        this.fetch_subcategories(this.selected_category);
      }

      if (product.attributes?.length) {
        product.attributes.forEach(attr => {

          const key = attr.attribute_type?.name || attr.attribute_type;
          const cleanKey = key.toLowerCase();

          if (!Reflect.get(this.update_item_form.attributes, cleanKey)) {
            Reflect.set(this.update_item_form.attributes, cleanKey, []);
          }
          Reflect.get(this.update_item_form.attributes, cleanKey).push(attr.value);
        });
      }


      // Reset upload_files for new uploads
      this.upload_files = [];

      // Populate previews with existing images
      this.previews = [];
      if (product.images && product.images.length) {
        product.images.forEach(img => {
          this.previews.push({
            type: 'image',
            src: img.image_url,
            id: img.id,
            _delete: false,   // mark for deletion if user removes
          });
        });
      }

    },

    update_product() {
      this.isEditing = true;
      if (!this.update_item_form.product_id) return;
      this.isLoading = true;

      update_catalogue_item({
        update_item_form: this.update_item_form,
        base_profile_id: this.base_profile_id,
        upload_files: this.upload_files,
        previews: this.previews,
        token: this.getToken(),
      })
        .then((response) => {
          if (response.status === "success") {
            const updatedProduct = response.data;
            const productIndex = this.profile_products.findIndex(p => p.id === updatedProduct.id);
            if (productIndex !== -1) {
              this.profile_products.splice(productIndex, 1, updatedProduct);
              this.catalogue_products = this.profile_products.filter(p => p.product_type?.name !== 'service' || p.product_type === null);
              this.catalogue_services = this.profile_products.filter(p => p.product_type?.name === 'service');
            } else {
              this.profile_products.push(updatedProduct);
              this.catalogue_products = this.profile_products.filter(p => p.product_type?.name !== 'service' || p.product_type === null);
              this.catalogue_services = this.profile_products.filter(p => p.product_type?.name === 'service');
            }
            this.reset_product_form();
            $('#manageProductModal').modal('hide');

            Swal.fire({
              icon: "success",
              text: 'Product updated successfully!',
              timer: 2000,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            });
          } else {
            this.reset_product_form();
            console.error(response.message || "Failed to update product");
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response.message || 'Failed to update product'
            });
          }
        })
        .catch((xhr) => {
          console.error(xhr.responseText || "Failed to update product");
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update product. Please try again.'
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    fetch_categories() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_categories/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          if (response.status === 'success') {
            this.categories = response.categories;
            if (this.modal_product?.category) {
              const cat = this.categories.find(c => c.name === this.modal_product.category);
              if (cat) {
                this.selected_category = cat.id;

                // fetch subcategories so the subcategory dropdown is populated
                this.fetch_subcategories(cat.id);
              }
            }
          }
        }
      });
    },

    fetch_subcategories(category_id) {
      this.selected_subcategory = null; // reset

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_subcategories/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          category_id: category_id,
        }),

        success: (response) => {
          if (response.status === "success") {
            this.subcategories = response.subcategories;
            if (this.modal_product?.subcategory) {
              const sub = this.subcategories.find(s => s.name === this.modal_product.subcategory);
              if (sub) this.update_item_form.subcategory_id = sub.id;
            }
          }
        }
      });

    },

    add_attribute_value(type) {
      const targetForm = this.isEditing
        ? this.update_item_form
        : this.item_form;

      add_attribute_value(targetForm, this.new_attribute_value, type);
    },
    handle_attribute_input_keydown(event, type) {
      if (!event || !type) return;
      if (event.key === "Enter" || event.key === ",") {
        event.preventDefault();
        this.add_attribute_value(type);
      }
    },
    group_attributes(attributes) {
      return group_attributes(attributes);
    },

    remove_attribute(item_form, type_name, index) {
      return remove_attribute(item_form, type_name, index);
    }


  }

}
